import { useRouteError, isRouteErrorResponse, Link } from 'react-router-dom';
import { Button, InlineError } from '@wapharma/design-system';
import { AdminStatusPage } from './AdminStatusPage';

export function AdminRouteError() {
  const err = useRouteError();
  const message = isRouteErrorResponse(err)
    ? `${err.status} ${err.statusText}`
    : err instanceof Error
      ? err.message
      : 'Erreur inattendue';
  const isNotFound = isRouteErrorResponse(err) && err.status === 404;
  const title = isNotFound ? 'Page introuvable' : 'Une erreur est survenue';

  return (
    <AdminStatusPage
      variant={isNotFound ? 'not-found' : 'error'}
      title={title}
      breadcrumbs={[
        { label: 'Accueil', href: '/' },
        { label: isNotFound ? 'Erreur 404' : 'Erreur' },
      ]}
      description={<InlineError title="Détail">{message}</InlineError>}
    >
      <Button as={Link} to="/" variant="primary">
        Retour à l&apos;accueil
      </Button>
    </AdminStatusPage>
  );
}
